<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
        <ng-container *ngFor="let item of breadcrumbs; let last = last; let i = index">
            <ng-container *ngIf="last">
                <strong *tuiItem tuiFade>
                    {{ item }}
                </strong>
            </ng-container>
            <ng-container *ngIf="!last">
                <button *tuiItem tuiLink type="button" (click)="navigateTo(i)">
                    {{ item }}
                </button>
            </ng-container>
        </ng-container>
    </tui-breadcrumbs>
</nav>

<section class="mb-20">
    <div class="mt-5 relative">
        <div *ngIf="!isLoading" class="w-full bg-[#E5EDFF] h-[124px] rounded-t-xl flex items-center justify-end">
            <div class="h-[32px] w-[85px] rounded-full flex items-center justify-center mr-8"
                [style.background-color]="user?.active ? '#6BC68A' : '#FF6B6B'">
                <p class="text-[#FFFFFF] text-sm font-bold">
                      {{  user?.active ? 'Active' : 'Inactive' }}
                </p>
            </div>
        </div>
        <div class="w-full h-[124px] flex items-center">
            <div class="ml-64 flex items-start justify-between w-full">
                <div>
                    <p class="text-2xl font-bold m-0 text-[#000000A6]">{{user?.name}} <span
                            class="text-[#526ED3] text-base font-medium">{{user?.refNo}}</span></p>
                    <p class="text-[#6B6D80] text-sm font-medium m-0 pt-2">Account Created on {{user?.createdAt | date:
                        'MMM d, y'}}</p>
                </div>
                <!-- button div -->
                <button appearance="flat" class="border custom-icon-button" iconStart="@tui.ellipsis-vertical"
                    tuiIconButton type="button" [tuiAppearanceState]="open ? 'hover' : null" [tuiDropdown]="content"
                    [(tuiDropdownOpen)]="open" [appDisableUnlessPermission]="'USER_UPDATE'">
                    Open
                </button>

                <ng-template #content>
                    <tui-data-list tuiDataListDropdownManager [size]="size">
                        <button *ngIf="!user.archived" tuiOption type="button" class="dropdown-button" [routerLink]="['/admin/users/add-edit', user?._id]" [appDisableUnlessPermission]="'USER_UPDATE'">
                            Edit 
                        </button>
                        <button tuiOption type="button" class="dropdown-button" (click)="resetUserPassword(user?.email)" [appDisableUnlessPermission]="'USER_UPDATE'">
                            Reset Password
                        </button>
                        <button tuiOption type="button" class="dropdown-button" (click)="toggleActive()" [appDisableUnlessPermission]="'USER_UPDATE'">
                            {{ user?.active ? 'Deactivate' : 'Activate' }}
                        </button>
                        <button tuiOption type="button" class="dropdown-button" (click)="toggleArchive()" [appDisableUnlessPermission]="'USER_UPDATE'">
                            {{ user?.archived ? 'Unarchive' : 'Archive' }}
                        </button>
                    </tui-data-list>
                </ng-template>


            </div>

        </div>
        <div class="w-[180px] h-[180px] rounded-full absolute top-10 left-10">
            <img class="object-cover w-full h-full rounded-full" src="{{user?.profilePic}}" alt="">

        </div>

    </div>
    <div class="flex">
        <div class="inline-block">
            <p class="text-base font-medium text-[#3E4A58] my-0">User Information</p>
            <p class="text-sm font-semibold text-[#949494D9] my-0">View Supplier information</p>

        </div>
        <div class="inline-block pl-[5.5rem]">
            <div>
                <p class="text-sm text-[#595959] font-medium my-0">Email Address</p>
                <p class="text-[#526ED3] text-xl font-bold my-0">{{user?.email}}</p>
            </div>
            <div class="pt-5">
                <p class="text-sm text-[#595959] font-medium my-0">Phone Number</p>
                <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">{{user?.contactNo}}</p>
            </div>

        </div>

    </div>
    <div class="flex mt-8">
        <div class="inline-block">
            <p class="text-base font-medium text-[#3E4A58] my-0">Notes</p>
            <p class="text-sm font-semibold text-[#949494D9] my-0">View notes</p>

        </div>
        <div class="inline-block pl-[210px] lg:pl-[210px] xl:pl-[11.4rem] 2xl:pl-[11.4rem]">
            <div style="border: 1px solid #D1D5DB; border-radius: 6px; padding: 16px;">
                <p
                    class="text-[0.938rem] text-[#1B1F3BA6] font-medium my-0 w-full md:w-full lg:w-full xl:w-[760px] 2xl:w-[960px] h-full">
                    {{user?.notes}}</p>
            </div>
        </div>

    </div>
</section>